import script from "./order-report-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./order-report-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__